import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { groupBy, uniq } from 'lodash';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const GraficoBarra = ({ dados, xKey, descricaoKeys = [], valorKey }) => {
  if (
    !dados ||
    dados.length === 0 ||
    !valorKey ||
    !xKey ||
    descricaoKeys.length === 0
  )
    return null;

  const getSerieKey = d => descricaoKeys.map(k => d[k]).join(' - ');
  const seriesKeys = uniq(dados.map(getSerieKey));
  const agrupadoPorTempo = groupBy(dados, d => d[xKey]);

  const data = Object.entries(agrupadoPorTempo).map(([x, valores]) => {
    const ponto = { [xKey]: x };
    valores.forEach(v => {
      ponto[getSerieKey(v)] = parseFloat(v[valorKey]) || 0;
    });
    return ponto;
  });

  const cores = [
    '#8884d8',
    '#82ca9d',
    '#ffc658',
    '#ff7300',
    '#d0ed57',
    '#a4de6c',
    '#8dd1e1',
    '#83a6ed',
    '#ffbb28',
    '#ff8042',
    '#00C49F',
    '#0088FE'
  ];

  const formatarData = formatarDataFuncion(xKey);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} tickFormatter={formatarData} />
        <YAxis />
        <Tooltip labelFormatter={formatarData} />
        <Legend />
        {seriesKeys.map((key, idx) => (
          <Bar
            key={key}
            dataKey={key}
            fill={cores[idx % cores.length]}
            name={key}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default GraficoBarra;

function formatarDataFuncion(xKey) {
  return valor => {
    try {
      if (!valor) return '';
      if (!isNaN(valor)) {
        return valor.toString();
      }

      const parsed = parseISO(valor);
      if (xKey.includes('month')) {
        return format(parsed, 'MMM/yyyy', { locale: ptBR });
      } else if (xKey.includes('quarter')) {
        const mes = parsed.getMonth();
        const trimestre = Math.floor(mes / 3) + 1;
        return `T${trimestre}/${parsed.getFullYear()}`;
      } else if (xKey.includes('year')) {
        return parsed.getFullYear().toString();
      } else {
        return format(parsed, 'dd/MM/yyyy', { locale: ptBR });
      }
    } catch {
      return valor;
    }
  };
}
